import {cargoApiURL} from '@yandex-delivery/client-core/api/corp'
import {fetch} from '@logistics-frontend/core/utils/network'
import {addQuery} from '@yandex-delivery/utils'

import type {CargoCrmRepository as CargoCrmRepositoryType} from './types'

function withFlowPhoenix(path: string) {
  return cargoApiURL(`cargo-crm/flow/phoenix/${path}`)
}

export const CargoCrmRepository: CargoCrmRepositoryType = {
  fetchState(body) {
    return fetch({
      url: withFlowPhoenix('state'),
      method: 'post',
      body,
      headers: {
        'Content-Type': 'application/json',
      },
    })
  },
  fetchTicketInit(body, query) {
    return fetch({
      url: addQuery(withFlowPhoenix('ticket/init'), query),
      method: 'post',
      body,
    })
  },
  fetchTicketState(query) {
    return fetch({
      url: addQuery(withFlowPhoenix('ticket/state'), query),
      method: 'get',
    })
  },
  fetchFillCompanyInfo(body, query) {
    return fetch({
      url: addQuery(withFlowPhoenix('ticket/fill-company-info'), query),
      method: 'post',
      body,
    })
  },
}
